module.exports = __webpack_public_path__ + "static/media/selection_arrow.8c1a3be6.png";